import { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Header } from "@/components/Header";
import { HeaderV13 } from "@/components/HeaderV13";
import { Hero } from "@/components/Hero";
import { HeroV13 } from "@/components/HeroV13";
import { FamilySelector } from "@/components/FamilySelector";
import { FamilySelectorV12 } from "@/components/FamilySelectorV12";
import { RealLifeSection } from "@/components/RealLifeSection";
import { TransformationSection } from "@/components/TransformationSection";
import { TransformationSectionV13 } from "@/components/TransformationSectionV13";
import { MotionSection } from "@/components/MotionSection";
import { MotionSectionV13 } from "@/components/MotionSectionV13";
import { BuiltDifferent } from "@/components/BuiltDifferent";
import { LongevitySection } from "@/components/LongevitySection";
import { ValueSectionV13 } from "@/components/ValueSectionV13";
import { AwardsSectionV13 } from "@/components/AwardsSectionV13";
import { CommunitySectionV13 } from "@/components/CommunitySectionV13";
import { SetupSectionV13 } from "@/components/SetupSectionV13";
import { TrustSection } from "@/components/TrustSection";
import { CommunitySection } from "@/components/CommunitySection";
import { SetupSection } from "@/components/SetupSection";
import { EcosystemSection } from "@/components/EcosystemSection";
import { Footer } from "@/components/Footer";
import { heroMediaV12 } from "@/config/media";

const HomePage = () => (
  <>
    <Header />
    <main>
      <Hero />
      <FamilySelector />
      {/* Phase 03+ sections (transformation, features, reviews, footer)
          are intentionally not rendered yet. Direction review happens first. */}
    </main>
  </>
);

const HomePageV12 = () => (
  <>
    <Header />
    <main>
      <Hero image={heroMediaV12} />
      <FamilySelectorV12 />
      <TransformationSection />
      <MotionSection />
      <BuiltDifferent />
      <LongevitySection />
      <TrustSection />
      <CommunitySection />
      <SetupSection />
      <EcosystemSection />
    </main>
    <Footer />
  </>
);

const HomePageV13 = () => (
  <div style={{ "--strollee-dark": "#0F1A15" }}>
    <HeaderV13 />
    <main>
      <HeroV13 />
      <RealLifeSection />
      <TransformationSectionV13 />
      <MotionSectionV13 />
      <BuiltDifferent />
      <ValueSectionV13 />
      <AwardsSectionV13 />
      <CommunitySectionV13 />
      <SetupSectionV13 />
      <EcosystemSection />
    </main>
    <Footer />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let frame;
    const raf = (time) => {
      lenis.raf(time);
      frame = requestAnimationFrame(raf);
    };
    frame = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(frame);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="strollee-grain min-h-screen bg-[var(--strollee-bg)]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/v1.2" element={<HomePageV12 />} />
          <Route path="/v1.3" element={<HomePageV13 />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
